import { LitElement, html } from 'lit';
import styles from './styles';

class StepWizardProgress extends LitElement {
  static properties = {
    steps: { type: Array },
    stepStyles: { type: Array },
    disableProgress: { type: Boolean },
    className: { type: String },
    activeStep: { type: Number },
  };

  constructor() {
    super();
    this.steps = [];
    this.stepStyles = [];
    this.showProgressBar = false;
    this.disableProgress = true;
    this.className = '';
    this.activeStep = 0;
  }

  static styles = styles;

  setActiveStep(index) {
    const event = new CustomEvent('set-active-step', {
      detail: { step: index },
      bubbles: true,
      composed: true,
    });
    this.dispatchEvent(event);
  }

  render() {
    return html`
      <nav class="step-wizard-progress ${this.className}">
        ${this.steps.map((step, index) => {
    const style = this.stepStyles[index] || '';
    const disabled = this.disableProgress || step.disableProgress;
    return html`
        <div class="step-wizard-progress-item">
          <div class="step-wizard-progress-line-before ${style}"
            style="${index === 0 ? 'display:none;' : ''}"></div>
          <div class="step-wizard-progress-line-after ${style}"
            style="${index === this.steps.length - 1 ? 'display:none;' : ''}"></div>
          <div class="step-wizard-progress-icon">
            <button
              class="step-wizard-progress-btn btn-sm ${style} ${disabled ? 'disabled' : ''}"
              ?disabled=${disabled}
              @click="${() => !disabled && this.setActiveStep(index)}"
              type="button"
            >
              ${index + 1}
            </button>
            <div class="step-wizard-progress-label ${style}">
              ${step.stepName || `Step ${index + 1}`}
            </div>
          </div>
        </div>
      `;
  })}
      </nav>
    `;
  }
}

customElements.define('tenable-step-wizard-progress', StepWizardProgress);
